import React from 'react'

function Loader() {
    return (
        <div className="text-center my-3">
            <img src="https://smorasstats.com/STATSSQL/img/loading_spinner.gif" className="loadingSpinner" alt="loadingspinner" />
        </div>
    )
}
export default Loader